import { useEffect, useState } from 'react'
import eventsService from 'services/eventsService'
import { EventProps } from 'types/event'

export default function useEvent(slug: string) {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<EventProps | null>(null)

  const fetchData = async () => {
    const club = await eventsService.getBySlug(slug)
    setData(club)
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { data, loading }
}
